import React, { useState, useEffect } from "react";
import './CryptoPrices.css';
const CryptoPrices = () => {
  // Define decimal places for each currency
  const decimals = {
    BTC: 2,
    ETH: 2,
    XAU: 3,
    AUD: 5,
  };

  // Initial static data (can be replaced with API data)
  const [prices, setPrices] = useState({
    BTC: { price: 80247.93, change: 0.23 },
    ETH: { price: 1888.16, change: -6.54 },
    XAU: { price: 2901.259, change: 0.45 },
    AUD: { price: 0.62721, change: -0.07 },
  });

  // Fetch real-time prices (example with BTC and ETH)
  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const response = await fetch(
          "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin,ethereum&vs_currencies=usd&include_24hr_change=true"
        );
        const data = await response.json();
        setPrices((prev) => ({
          ...prev,
          BTC: { price: data.bitcoin.usd, change: data.bitcoin.usd_24h_change },
          ETH: { price: data.ethereum.usd, change: data.ethereum.usd_24h_change },
        }));
      } catch (error) {
        console.error("Error fetching prices:", error);
      }
    };

    fetchPrices();
    const interval = setInterval(fetchPrices, 5000); // Update every 5 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-row justify-around p-6 bg-white shadow-lg rounded-xl border-bottom">
      {Object.entries(prices).map(([key, { price, change }]) => (
        <div key={key} className="text-center">
          {/* Currency Pair Label */}
          <h3 className="text-sm font-small text-gray-500 mb-2   h2-crypto">
            {key === "BTC"
              ? "BTC/USDT"
              : key === "ETH"
              ? "ETH/USDT"
              : key === "XAU"
              ? "XAU/USD"
              : "AUD/USD"}
          </h3>
          {/* Price */}
          <p className={`text-2xl font-semibold mb-1 ${change >= 0 ? "text-green-600" : "text-red-600"}`}>
            {price.toLocaleString("en-US", {
              minimumFractionDigits: decimals[key],
              maximumFractionDigits: decimals[key],
            })}
          </p>
          {/* Percentage Change */}
          <p
            className={`text-sm font-medium ${
              change >= 0 ? "text-green-600" : "text-red-600"
            }`}
          >
            {change >= 0 ? "+" : ""}
            {change.toFixed(2)}%
          </p>
        </div>
      ))}
    </div>
  );
};

export default CryptoPrices;